import React from "react";
import {
  InputCheck,
  InputCheckNo,
  InputCheckNone,
  InputCheckYes,
  InputSingleCheck,
  NuFormInput,
  NuFormSelect,
  NuFormTextArea,
  NuTableFormInput,
  NuTableFormSelect,
} from "./Input";
import useFetchMataData from "../Hooks/useFetchMataData";

function CDynamicFormTwo({
  formData,
  expandedIndex,
  index,
  allValue = [],
  setAllValue = () => {},
  editModeIndex,
}) {
  const { value: unit, getData: refunit } = useFetchMataData(
    `/dropdown/dropdown-details/`,
    "unit_equipments"
  );

  function giveValue(value) {
    let length = 1;
    if (typeof value?.metadata === "object" && value?.metadata !== null) {
      length = Object.keys(value.metadata).length;
    }

    function getMultivalue({key="",value="",fieldLabel="",fieldType="",length=1,id=0}) {
      switch (value) {
        case "text":
          return (
            <>
              <div
                className={` ${
                  length >= 3
                    ? "col-span-2"
                    : length >= 2
                    ? "col-span-4"
                    : "col-span-8"
                } w-full flex justify-end text-end items-center gap-2`}
              >
                {key !== fieldLabel && (
                  <p className=" w-1/3 text-xs mr-1.5">{key || ""}</p>
                )}
                <NuFormInput
                  label={key}
                  type={"text"}
                  // formik={formik}
                  placeholder={fieldLabel}
                  name={value}
                  id={id}
                  field_type={fieldType}
                  allValue={allValue}
                  setAllValue={setAllValue}
                  width={" w-2/3 "}
                  disabled={editModeIndex !== index}
                />
              </div>
            </>
          );
        case "number":
          return (
            <>
              <div
                className={` ${
                  length >= 4
                    ? "col-span-2"
                    : length >= 2
                    ? "col-span-4"
                    : "col-span-8"
                } w-full flex justify-end text-end items-center gap-2`}
              >
                {key !== fieldLabel && (
                  <p className=" w-1/3 text-xs mr-1.5">{key || ""}</p>
                )}
                <NuFormInput
                  label={key}
                  type={"number"}
                  // formik={formik}
                  placeholder={key}
                  name={value}
                  id={id}
                  field_type={fieldType}
                  allValue={allValue}
                  setAllValue={setAllValue}
                  width={" w-2/3 "}
                  disabled={editModeIndex !== index}
                />
              </div>
            </>
          );
        case "string":
          return (
            <div className=" w-full text-xs ">
              <p className=" w-full">{key || ""}</p>
            </div>
          );
        case "yesno":
          return (
            <div
              className={` ${
                length >= 3
                  ? "col-span-2"
                  : length >= 2
                  ? "col-span-4"
                  : "col-span-8"
              } w-full flex justify-end text-end items-center gap-2`}
            >
              <p className=" w-1/3 text-xs mr-1.5">{key || ""}</p>
              <div className=" gap-x-1 grid grid-cols-3 w-full">
                <div className=" flex justify-center items-center gap-1.5">
                  <p>{"Yes" || ""}</p>
                  <InputCheckYes
                    type={"checkbox"}
                    //   formik={formik}
                    placeholder={""}
                    name={key}
                    id={id}
                    field_type={fieldType}
                    allValue={allValue}
                    setAllValue={setAllValue}
                    disabled={editModeIndex !== index}
                    label={key}
                  />
                </div>

                <div className="flex justify-center items-center gap-1.5">
                  <p>{"No" || ""}</p>
                  <InputCheckNo
                    type={"checkbox"}
                    // formik={formik}
                    placeholder={""}
                    name={fieldLabel}
                    id={id}
                    field_type={fieldType}
                    allValue={allValue}
                    setAllValue={setAllValue}
                    disabled={editModeIndex !== index}
                    label={fieldLabel}
                  />
                </div>

                <div className="flex justify-center items-center gap-1.5">
                  <p>{"N/A" || ""}</p>
                  <InputCheckNone
                    type={"checkbox"}
                    //   formik={formik}
                    placeholder={""}
                    name={fieldLabel}
                    id={value?.id}
                    field_type={fieldType}
                    allValue={allValue}
                    setAllValue={setAllValue}
                    disabled={editModeIndex !== index}
                    label={fieldLabel}
                  />
                </div>
              </div>
            </div>
          );
        case "checkbox":
          return (
            <div
              className={` ${
                length >= 3
                  ? "col-span-2"
                  : length >= 2
                  ? "col-span-4"
                  : "col-span-8"
              } w-full flex justify-end text-end items-center gap-2`}
            >
              <p className="  text-xs text-right">{key || ""}</p>
              <InputCheck
                type={"checkbox"}
                //   formik={formik}
                placeholder={""}
                name={key}
                id={id}
                field_type={fieldType}
                allValue={allValue}
                setAllValue={setAllValue}
                disabled={editModeIndex !== index}
                label={key}
              />
            </div>
          );
        case "truefalse":
          return (
            <div
              className={` ${
                length >= 3
                  ? "col-span-2"
                  : length >= 2
                  ? "col-span-4"
                  : "col-span-8"
              } w-full flex justify-end text-end items-center gap-2`}
            >
              <p className="   text-xs text-right">{key || ""}</p>
              <InputCheck
                type={"checkbox"}
                //   formik={formik}
                placeholder={""}
                name={key}
                id={id}
                field_type={value}
                allValue={allValue}
                setAllValue={setAllValue}
                disabled={editModeIndex !== index}
                label={key}
              />
            </div>
          );
        case "yesnona":
          return (
            <div
              className={` ${
                length >= 3
                  ? "col-span-2"
                  : length >= 2
                  ? "col-span-4"
                  : "col-span-8"
              } w-full flex justify-end text-end items-center gap-2`}
            >
              <table className="w-full">
                <tr>
                  <td className="w-3/5 text-end px-2">
                    <p>{key}</p>
                  </td>
                  <td className="px-2">
                    <div className="flex justify-center items-center gap-1.5">
                      <p>{"Yes" || ""}</p>
                      <InputCheckYes
                        type={"checkbox"}
                        //   formik={formik}
                        placeholder={""}
                        name={fieldLabel}
                        id={id}
                        field_type={fieldType}
                        allValue={allValue}
                        setAllValue={setAllValue}
                        disabled={editModeIndex !== index}
                        label={fieldLabel}
                      />
                    </div>
                  </td>
                  <td className="px-2">
                    <div className="flex justify-center items-center gap-1.5">
                      <p>{"No" || ""}</p>
                      <InputCheckNo
                        type={"checkbox"}
                        //   formik={formik}
                        placeholder={""}
                        name={fieldLabel}
                        id={id}
                        field_type={fieldType}
                        allValue={allValue}
                        setAllValue={setAllValue}
                        disabled={editModeIndex !== index}
                        label={fieldLabel}
                      />
                    </div>
                  </td>
                  <td className="px-2">
                    <div className="flex justify-center items-center gap-1.5">
                      <p>{"N/A" || ""}</p>
                      <InputCheckNone
                        type={"checkbox"}
                        //   formik={formik}
                        placeholder={""}
                        name={fieldLabel}
                        id={id}
                        field_type={fieldType}
                        allValue={allValue}
                        setAllValue={setAllValue}
                        disabled={editModeIndex !== index}
                        label={fieldLabel}
                      />
                    </div>
                  </td>
                </tr>
              </table>
            </div>
          );
        case "dropdown":
          return (
            <div className={`w-full py-2 text-xs  `}>
              <table className="w-full">
                <tr>
                  <td className="w-5/12 text-end px-2">
                    <p>{key}</p>
                  </td>
                  <td className="px-2">
                    <NuFormSelect
                      name={key}
                      label={key}
                      placeholder={""}
                      id={id}
                      field_type={fieldType}
                      allValue={allValue}
                      setAllValue={setAllValue}
                      disabled={editModeIndex !== index}
                      options={unit || []}
                    />
                  </td>
                </tr>
              </table>
            </div>
          );
        case "textArea":
          return (
            <div className=" col-span-10">
              <NuFormTextArea
                placeholder={""}
                //   formik={formik}
                name={value}
                new_width={"w-5/6"}
                id={value?.id}
                field_type={fieldType}
                allValue={allValue}
                setAllValue={setAllValue}
                disabled={editModeIndex !== index}
                label={key}
              />
            </div>
          );
        default:
          return null;
      }
    }

    function getFieldType(value, length) {
      switch (value?.field_type) {
        case "text":
          return (
            <>
              <div className="col-span-2  flex items-center ">
                <p>{value?.field_label || " "}</p>
              </div>
              <div className="col-span-8   p-2">
                <div className={`w-full   grid gap-0.5 grid-cols-8 `}>
                  <div className=" col-span-2">
                    <NuFormInput
                      label={""}
                      type={value?.type}
                      //   formik={formik}
                      placeholder={value?.Name}
                      name={value?.value}
                      width={"w-full"}
                      id={value?.id}
                      field_type={value?.field_type}
                      allValue={allValue}
                      setAllValue={setAllValue}
                      disabled={editModeIndex !== index}
                    />
                  </div>
                </div>
              </div>
            </>
          );
        case "number":
          return (
            <>
              <div className="col-span-2  flex items-center">
                <p>{value?.field_label || " "}</p>
              </div>
              <div className="col-span-8   p-2">
                <div className={`w-full   grid gap-0.5 grid-cols-8 `}>
                  <div className=" col-span-2">
                    <NuFormInput
                      label={""}
                      type={value?.type}
                      //   formik={formik}
                      placeholder={value?.Name}
                      name={value?.value}
                      width={"w-full"}
                      id={value?.id}
                      field_type={value?.field_type}
                      allValue={allValue}
                      setAllValue={setAllValue}
                      disabled={editModeIndex !== index}
                    />
                  </div>
                </div>
              </div>
            </>
          );
        case "date":
        case "Date":
          return (
            <>
              <div className="col-span-2  ">
                <p>{value?.field_label || " "}</p>
              </div>
              <div className="col-span-8   p-2">
                <div className={`w-full   grid gap-0.5 grid-cols-8 `}>
                  <div className=" col-span-2">
                    <NuFormInput
                      label={""}
                      type={"date"}
                      //   formik={formik}
                      placeholder={value?.Name}
                      name={value?.value}
                      width={"w-full"}
                      id={value?.id}
                      field_type={value?.field_type}
                      allValue={allValue}
                      setAllValue={setAllValue}
                      disabled={editModeIndex !== index}
                    />
                  </div>
                </div>
              </div>
            </>
          );
        case "string":
          return (
            <div className={` ${value?.width} py-2 text-xs  mt-5 `}>
              <table className="w-full">
                <tr>
                  <td className="w-full">
                    <p>{value?.Name}</p>
                  </td>
                </tr>
              </table>
            </div>
          );
        case "yesnona":
        case "yesno":
          return (
            <>
              <div className="col-span-2  flex items-center">
                <p>{value?.field_label || " "}</p>
              </div>
              <div className="col-span-8   p-2">
                <div className={`w-full   grid gap-0.5 grid-cols-8 `}>
                  <>
                    <div className="col-span-2 flex justify-center items-center gap-1.5">
                      <InputCheckYes
                        type={"checkbox"}
                        // formik={formik}
                        placeholder={""}
                        name={value?.field_label}
                        id={value?.id}
                        field_type={value?.field_type}
                        allValue={allValue}
                        setAllValue={setAllValue}
                        disabled={editModeIndex !== index}
                        label={value?.field_label}
                      />
                      <p>{"Yes" || ""}</p>
                    </div>

                    <div className="col-span-2 flex justify-center items-center gap-1.5">
                      <p>{"No" || ""}</p>
                      <InputCheckNo
                        type={"checkbox"}
                        //   formik={formik}
                        placeholder={""}
                        name={value?.field_label}
                        id={value?.id}
                        field_type={value?.field_type}
                        allValue={allValue}
                        setAllValue={setAllValue}
                        disabled={editModeIndex !== index}
                        label={value?.field_label}
                      />
                    </div>

                    <div className="col-span-2 flex justify-center items-center gap-1.5">
                      <p>{"N/A" || ""}</p>
                      <InputCheckNone
                        type={"checkbox"}
                        //   formik={formik}
                        placeholder={""}
                        name={value?.field_label}
                        id={value?.id}
                        field_type={value?.field_type}
                        allValue={allValue}
                        setAllValue={setAllValue}
                        disabled={editModeIndex !== index}
                        label={value?.field_label}
                      />
                    </div>
                  </>
                </div>
              </div>
            </>
          );
        case "checkbox":
          const items = Object.entries(value?.metadata);
          return (
            <>
              <div className="col-span-2  flex items-center">
                <p>{value?.field_label || " "}</p>
              </div>
              <div className="col-span-8   p-2">
                <div className={`w-full   grid gap-0.5 grid-cols-8 `}>
                  <>
                    {items.map(([key, valueOf], idx) => (
                      <div className=" col-span-2 flex justify-center items-center gap-1.5">
                        <InputCheck
                          fullValue={value?.value}
                          label={key}
                          // formik={formik}
                          placeholder=""
                          name={key}
                          id={value?.id}
                          field_type={value?.field_type}
                          allValue={allValue}
                          setAllValue={setAllValue}
                          disabled={editModeIndex !== index}
                        />
                        <p>{key}</p>
                      </div>
                    ))}
                  </>
                </div>
              </div>
            </>
          );
        case "single_checkbox":
          return (
            <>
              <div className="col-span-2  flex items-center">
                <p>{value?.field_label || " "}</p>
              </div>
              <div className="col-span-8   p-2">
                <div className={`w-full   grid gap-0.5 grid-cols-8 `}>
                  <>
                    {value?.metadata &&
                      Object.entries(value?.metadata).map(([key, valueOf]) => (
                        <div className="col-span-2 flex flex-row-reverse justify-start items-center gap-2">
                          <InputSingleCheck
                            fullValue={value?.value}
                            label={key}
                            // formik={formik}
                            placeholder={""}
                            name={key}
                            id={value?.id}
                            field_type={value?.field_type}
                            allValue={allValue}
                            setAllValue={setAllValue}
                            disabled={editModeIndex !== index}
                          />
                          <p>{key || ""}</p>
                        </div>
                      ))}
                  </>
                </div>
              </div>
            </>
          );
        case "textArea":
        case "observation":
          return (
            <div className=" col-span-10">
              <NuFormTextArea
                label=""
                placeholder={value?.field_label || ""}
                //   formik={formik}
                name={value?.field_label}
                new_width={"w-full"}
                id={value?.id}
                field_type={value?.field_type}
                allValue={allValue}
                setAllValue={setAllValue}
                disabled={editModeIndex !== index}
              />
            </div>
          );
        case "tableHeaders":
          return (
            <div className=" w-full col-span-10">
              <table className="w-full border border-collapse ">
                              {
                value?.field_label == "FIRE EXTINGUISHER DETAILS" ? (
                <tr>
                  <th className=" text-left p-2">Legends :</th>
                  <th className=" text-left p-2">Good </th>
                  <th className=" text-left p-2">Defective </th>
                  <th className=" text-left p-2">Missing </th>
                  <th className=" text-left p-2">N/A </th>
                </tr>
              ) :(
                <thead>
                  <tr className=" w-full ">
                    {Object.entries(value?.metadata).length > 10 ? (
                      <>
                        {Object.entries(value?.metadata).map(
                          ([key, valueOf], idx) => (
                            <th
                              className=" [writing-mode:vertical-lr] max-h-[150px] rotate-180 p-2 text-left max-w-[100px]  py-2 text-xs border "
                              key={idx}
                            >
                              {key}
                            </th>
                          )
                        )}
                      </>
                    ) : (
                      <>
                        {Object.entries(value?.metadata).map(
                          ([key, valueOf], idx) => (
                            <th
                              className=" min-w-[150px] max-w-[250px] py-2 text-xs border "
                              key={idx}
                            >
                              {key}
                            </th>
                          )
                        )}
                      </>
                    )}
                  </tr>
                </thead>
              )}
              </table>
            </div>
          );
        case "tableItems":
          return (
            <>
              <table className="w-full col-span-10 border border-collapse  text-xs">
                {Array.isArray(value?.metadata) &&
                value?.metadata.length > 0 ? (
                  value?.metadata.map((item, indx) => (
                    <tr key={indx} className=" text-xs">
                      {/* <td className=" w-2/12 border">{value?.label||"-"}</td> */}
                      {Object.entries(item).map(([key, valueOf], idx) => (
                        <td
                          key={idx}
                          className="border py-1 px-2 max-w-[150px]"
                        >
                          {valueOf == "text" ? (
                            <>
                              <NuTableFormInput
                                label={key}
                                type={"text"}
                                // formik={formik}
                                placeholder={value?.Name}
                                name={`${key}${valueOf}${indx}`}
                                width={"w-full"}
                                id={value?.id}
                                field_type={value?.field_type}
                                allValue={allValue}
                                setAllValue={setAllValue}
                                disabled={editModeIndex !== index}
                                idx={indx + 1}
                              />
                            </>
                          ) : valueOf == "number" ? (
                            <>
                              <NuTableFormInput
                                label={key}
                                type={"text"}
                                // formik={formik}
                                placeholder={value?.Name}
                                name={`${key}${valueOf}${indx}`}
                                width={"w-full"}
                                id={value?.id}
                                field_type={value?.field_type}
                                allValue={allValue}
                                setAllValue={setAllValue}
                                disabled={editModeIndex !== index}
                                idx={indx + 1}
                              />
                            </>
                          ) : valueOf == "legends" ? (
                            <>
                              <NuTableFormSelect
                                label={key}
                                type={"text"}
                                // formik={formik}
                                placeholder={value?.Name}
                                name={`${key}${valueOf}${indx}`}
                                width={"w-full"}
                                id={value?.id}
                                field_type={value?.field_type}
                                allValue={allValue}
                                setAllValue={setAllValue}
                                disabled={editModeIndex !== index}
                                idx={indx + 1}
                                options={[
                                  {
                                    label: "c",
                                    value: "C",
                                  },
                                  {
                                    label: "t",
                                    value: "t",
                                  },
                                  {
                                    label: "o",
                                    value: "o",
                                  },
                                  {
                                    label: "N",
                                    value: "N",
                                  },
                                ]}
                              />
                            </>
                          ) : (
                            <NuTableFormInput
                              label={key}
                              type={"text"}
                              // formik={formik}
                              placeholder={value?.Name}
                              name={`${key}${valueOf}${indx}`}
                              width={"w-full"}
                              id={value?.id}
                              field_type={value?.field_type}
                              allValue={allValue}
                              setAllValue={setAllValue}
                              disabled={editModeIndex !== index}
                              idx={indx + 1}
                            />
                          )}
                        </td>
                      ))}
                    </tr>
                  ))
                ) : (
                  <td>
                    <p>No Data</p>
                  </td>
                )}

                {/* <tr>
                        <td className="w-2/12">
                          <p>{value?.field_label||""}</p>
                        </td>
        
                     </tr> */}
              </table>
            </>
          );
        case "heading":
          return (
            <>
              <div className={` w-full py-2 col-span-10 text-xs  mt-5 `}>
                <table className="w-full">
                  <tr>
                    <td className="w-full">
                      <p>{value?.field_label}</p>
                    </td>
                  </tr>
                </table>
              </div>
            </>
          );
        case "multi":
          return (
            <>
              <div className="col-span-2  flex items-center">
                <p>{value?.field_label || " "}</p>
              </div>
              <div className="col-span-8   p-2">
                <div className={`w-full   grid gap-0.5 grid-cols-8 `}>
                  {Object.entries(value?.metadata).map(([key, valueOf], i) => {
                    return getMultivalue(
                      {
                        key:key||"",
                        value:valueOf||"",
                        fieldLabel:value?.field_label||"",
                        fieldType:value?.field_type||"",
                        length:length||"",
                        id:value?.id||""
                      }
                    );
                  })}
                </div>
              </div>
            </>
          );
        default:
          return null;
      }
    }

    return (
      <div className="w-full grid grid-cols-10 gap-0.5 ">
        {getFieldType(value, length)}
      </div>
    );
  }

  return (
    <>
      <div className="w-full mx-auto h-auto  md:overflow-hidden   md:flex gap-2 text-[#111537]">
        <div className="w-full bg-white  overflow-y-scroll">
          <React.Fragment key={index}>
            <div className={` ${expandedIndex === index ? " " : ""}`}>
              {expandedIndex === index && (
                <div className=" ">
                  {formData &&
                    formData.map((tiltle, tiltleIndex) => {
                      return (
                        <div key={tiltleIndex} className="last:pb-4 ">
                          <label className="block text-sm 2xl:text-base font-medium text-white bg-baseColor-primary py-2 px-2">
                            {tiltle?.titleName || "-"}
                          </label>
                          {tiltle?.fields &&
                            tiltle?.fields.map((value, k) => {
                              return (
                                <div
                                  key={k}
                                  className="w-full border-b last:border-b-0 px-2.5 text-xs py-2 min-h-[90px] flex items-center "
                                >
                                  {giveValue(value)}
                                </div>
                              );
                            })}
                        </div>
                      );
                    })}
                </div>
              )}
            </div>
          </React.Fragment>
        </div>
      </div>
    </>
  );
}

export default CDynamicFormTwo;
